export default class InvalidTicketQRCodeException extends Error {
  override message = 'Invalid Ticket QR Code';
}
